import { render, staticRenderFns } from "./QueryPriceDownload.vue?vue&type=template&id=3be12fd8&scoped=true&"
import script from "./QueryPriceDownload.vue?vue&type=script&lang=js&"
export * from "./QueryPriceDownload.vue?vue&type=script&lang=js&"
import style0 from "./QueryPriceDownload.vue?vue&type=style&index=0&id=3be12fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be12fd8",
  null
  
)

export default component.exports